<template>
    <form :action="url" class="b-catalog__filter-group">
        <input v-if="sort" type="hidden" name="sort" :value="sort">
        <input v-if="search" type="hidden" name="search" :value="search">
        <input v-if="filters" type="hidden" name="filters_string" :value="filters">

        <input v-model="search"
               class="form-control"
               type="text"
               placeholder="Введите станцию"
        >

        <input v-for="id in checkedSubwaysId" type="hidden" name="subways[]" :value="id">

        <button class="button" type="submit">Применить</button>
    </form>

    <div class="b-catalog__filter-results">
        <div class="b-catalog__filter-subways" v-if="checkedSubways.length">
            <ul>
                <li v-for="checkedSubway in checkedSubways">
                    {{ checkedSubway.name }}

                    <span class="b-catalog__filter-subway-remove" @click.prevent="deleteSubway(checkedSubway.id)"></span>
                </li>
            </ul>
        </div>

        <form v-if="subways.length">
            <div class="b-catalog__filter-subway" v-for="subway in filteredSubways" :key="subway.id">
                <input type="checkbox" :id="subway.id" v-model="checkedSubwaysId" :value="subway.id">
                <label :for="subway.id">
                    <span class="w-subwayPointer" :style="{backgroundColor: subway.color}">М</span>
                    {{ subway.name }}
                </label>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
      return {
          search: '',
          filteredSubways: [],
          checkedSubwaysId: [],
          checkedSubways: [],
      }
    },
    props: {
        subways: {
            required: false,
            type: Array
        },
        actives: {
            required: false,
            type: Array
        },
        url: {
            required: false,
            type: String
        },
        sort: {
            required: false,
            type: String
        },
        search: {
            required: false,
            type: String
        },
        filters: {
          required: false,
          type: String
        },
    },
    created() {
        if(this.actives.length) {
            const actives = this.actives.map(Number);

            this.checkedSubwaysId = actives;
        }

        this.filteredSubways = this.$props.subways;
    },
    methods: {
        deleteSubway(id) {
            this.checkedSubwaysId = this.checkedSubwaysId.filter(x => x !== id);
        }
    },
    watch: {
        checkedSubwaysId(currentValue) {
            this.checkedSubways = this.$props.subways.filter(x => currentValue.includes(x.id));
        },
        search(currentValue) {
            this.filteredSubways = this.$props.subways.filter(
                subway => subway.name.toLowerCase().includes(currentValue.toLowerCase())
            );
        }
    }
};
</script>
